import request from './utils/request'

class Meinian {
  init(plugin) {
    if (plugin.userInfo) {
      this.userInfo = plugin.userInfo
      localStorage.setItem('userAuthCodeList', JSON.stringify(this.userInfo?.userAuthCodeList))
      localStorage.setItem('teamAuthCodeList', JSON.stringify(this.userInfo?.teamAuthCodeList))
    } else {
      this.initAccount()
    }
    if (plugin.teamInfo) {
      this.teamInfo = plugin.teamInfo
      sessionStorage.setItem('teamInfo', JSON.stringify(this.teamInfo))
    } else {
      this.initTeamInfo()
    }
    this.initTrack()
  }

  // eslint-disable-next-line class-methods-use-this
  async initAccount() {
    const res = await Promise.allSettled([
      request.get('/backend-api/app-dataline/data-line/team/team-sharing-setting'),
      request.get('/backend-api/app-dataline/data-line/user/user-perm'),
      request.get('/v1-5-1/hot/hot-taobao-category'), // 为了鲸选的一个参数
      request.get('/backend-api/sso-api/user/get-info'),
    ])
  
    const [
      { value: { teamSharingType } },
      { value: authInfo = {} },
      { value: categories = [] },
      { value: userInfo = {} },
    ] = res
  
    const accountInfo = {
      teamSharingType,
      ...userInfo,
      userAuthCodeList: authInfo.permCodeList || [],
      teamAuthCodeList: authInfo.teamPermCodeList || [],
    }
    if (categories) {
      accountInfo.rootCategoryIds = []
      accountInfo.rootCategories = categories.filter(m => m.authAble && m.aiData).map((m) => {
        accountInfo.rootCategoryIds.push(m.first.id)
        return m.first.name
      })
      accountInfo.categoryId = categories.filter(m => m.authAble)?.[0]?.second?.[0]?.id
      accountInfo.rootCategoryId = accountInfo.rootCategoryIds[0]
      if (accountInfo && accountInfo.phone) {
        accountInfo.userPhone = Number(accountInfo.phone)
      }
    }
    accountInfo.categories = categories
    localStorage.userAuthCodeList = JSON.stringify(accountInfo.userAuthCodeList)
    localStorage.teamAuthCodeList = JSON.stringify(accountInfo.teamAuthCodeList)
    sessionStorage.setItem('account', JSON.stringify(accountInfo))
    this.userInfo = accountInfo
  }

  async initTeamInfo() {
    const authInfo = await request.get('/backend-api/sso-api/team/auth-info')
    const userInfo = await request.get('/backend-api/app-dataline/data-line/user/user-info')
    const baseInfo = await request.get('/backend-api/sso-api/team/base-info')
    const personalInfo = await request.get('/backend-api/sso-api/user/get-info')
    const teamInfo = await request.get('/backend-api/app-dataline/data-line/team/get-team-info')
    sessionStorage.setItem('teamInfo', JSON.stringify({ ...authInfo, ...teamInfo, ...userInfo, ...baseInfo, ...personalInfo }))
    this.teamInfo = { ...authInfo, ...teamInfo, ...userInfo, ...baseInfo, ...personalInfo }
  }

  // eslint-disable-next-line class-methods-use-this
  async initTrack() {
    if (!window.sessionHistory || window.sessionHistory.length === 0) {
      window.sessionHistory = [
        window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_'),
        window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_')
      ]
    }
  }
}

export default new Meinian()
